<div class="verify-dialog-container">
  <h2 translate="AUTH.VERIFY.HEADER"></h2>
  <button mat-button class="close-button" [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>

  <gb-verify-form [dialog]="true" [verifyExtras]="data"></gb-verify-form>
</div>
